
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-town/tree",
      function () {
        return require("private-next-pages/token-town/tree.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-town/tree"])
      });
    }
  